import './App.css';
import Search from './components/search/Search';
import CurrentWeather from './components/current-weather/current-weather';
import Forecast from './components/forecast/Forecast';
import { Weather_APT_URL, Weather_APT_Key } from './fetchAPI/api';
import { useState } from 'react';

function App() {

  const [currentWeather, setCurrentWeather] = useState(null);
  const [forecast, setForecast] = useState(null);

  const handleOnSearchChange = (searchData) => {
    const [lat, lon] = searchData.value.split(" ");

    const currentWeatherFetch = fetch(`${Weather_APT_URL}/weather?lat=${lat}&lon=${lon}&appid=${Weather_APT_Key}&units=metric`);
    const forecastFetch = fetch(`${Weather_APT_URL}/forecast?lat=${lat}&lon=${lon}&appid=${Weather_APT_Key}&units=metric`);

    Promise.all([currentWeatherFetch, forecastFetch])
      .then(async (response) => {
        const weatherResponse = await response[0].json();
        const forecastResponse = await response[1].json();

        setCurrentWeather({ city: searchData.label, ...weatherResponse });
        setForecast({ city: searchData.label, ...forecastResponse });
      })

      .catch((err) => console.log(err));

  }


  return (
    <div>
      <div className="container">
        <Search onSearchChange={handleOnSearchChange} />
        {currentWeather && <CurrentWeather data={currentWeather} />}
        {forecast && <Forecast data={forecast} />}
      </div>
      <div className="footer-box">
        <footer className="footer">
          <p>
            Weather Cast <br />
            Made with ❤️ by
            <space>  </space>
            <a href='https://www.linkedin.com/in/jaskaran-singh-dev/' target="_blank" rel="noreferrer">Jaskaran Singh</a>
          </p>
        </footer>
      </div>
    </div>

  );
}

export default App;
